import type { TierMeta } from "./types";

export const TIER_META: Record<string, TierMeta> = {
  basic: {
    label: "Basic",
    description: "Every game, live & on-demand,\nacross all three leagues.",
    features: [
      "Live & on-demand access",
      "All three leagues",
      "Standard video quality",
    ],
  },
  insider: {
    label: "Insider",
    description:
      "Everything in Basic, plus personalized\nchannels, watch parties & clip downloads.",
    features: [
      "All Basic features",
      "Personalized channels",
      "Watch parties",
      "Clip downloads",
    ],
  },
};

export const tierLabel = (tier: string) =>
  TIER_META[tier]?.label ||
  (tier ? tier.charAt(0).toUpperCase() + tier.slice(1) : "");
